// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__eBm1P","list":"PatternAutocomplete_list__32lcg"};